// extracted by mini-css-extract-plugin
export default {"Screen":"Screen_Screen__0ghyk","Header":"Screen_Header__xSHug","ScreenStory":"Screen_ScreenStory__L+kjf"};